// EXP1-S1 (docs/build-briefs/EXP1-S1-export-pipeline-csv-xlsx.md; DEC-402): the formats the Export menu offers, as DATA.
// No DOM, so a plain node:test file can import it. Google Sheet (EXP1-S6) is not a list entry: the menu adds it as
// a last item only for a screen that opts in and only when a Google client id is configured (googleSheets.ts).

export type ExportFormat = "csv" | "xlsx" | "pdf";

/** EXP1-S6: what a LOCATION report screen may ask the server for. `google_sheet` is the same workbook as `xlsx`, audited
 * as google_sheet, which the browser uploads to the person's own Drive. The franchisor and Software Owner consoles keep
 * the three file formats only. */
export type GateExportFormat = ExportFormat | "google_sheet";

export interface ExportFormatChoice {
  readonly format: ExportFormat;
  readonly label: string;
  /** The file extension, also the server's `format` value. */
  readonly extension: string;
}

export const EXPORT_FORMAT_CHOICES: readonly ExportFormatChoice[] = [
  { format: "csv", label: "CSV", extension: "csv" },
  { format: "xlsx", label: "Excel", extension: "xlsx" },
  { format: "pdf", label: "PDF", extension: "pdf" },
];

/** `<stem>.<extension>` for a download, e.g. fileNameFor("closeout_2026-10-13", "xlsx"). */
export function fileNameFor(stem: string, format: GateExportFormat): string {
  // A Google Sheet is named for the report with no extension; the workbook is converted on upload.
  if (format === "google_sheet") {
    return stem;
  }
  const choice = EXPORT_FORMAT_CHOICES.find((c) => c.format === format);
  if (choice === undefined) {
    throw new Error(`unknown export format: ${format}`);
  }
  return `${stem}.${choice.extension}`;
}
